export function stateWarn(state, message) {
    const vfile = state.env.vfile;
    if (!vfile)
        return;
    return vfile.message(message);
}
export function stateError(state, message) {
    const out = stateWarn(state, message);
    if (out)
        out.fatal = true;
    return out;
}
